export enum TrackedEvents {
  /** Add property to hold constant */
  AddPropertyConstant = `Add property constant`,
  /** Edit property to hold constant */
  EditPropertyConstant = `Edit property constant`,
  /** Remove property to hold constant */
  RemovePropertyConstant = `Remove property constant`,
  /** Edit funnel conversion window */
  EditConversionWindow = `Edit conversion window`,
  /** Edit counts (unique/total/sessions) */
  EditCounts = `Edit counts`,
}
